// const DEFAULT_BASE_URL = 'http://localhost:8000/api';
const DEFAULT_BASE_URL = 'https://api.nskrepair.com/api';

const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || DEFAULT_BASE_URL;

// Function to make API requests for contact form submissions
export const ContactAPI = `${BASE_URL}/contact`;
export const BusinessInquiryAPI = `${BASE_URL}/business-inquiry`;


//Funtion to make API requests for booking form submissions
export const BookingAPI = `${BASE_URL}/bookings`;
